<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";

import {SmartOfferBundleTreasureType} from "@/modules/redactor/models/smart-offer/bundle-treasure/SmartOfferBundleTreasureType";

export default {
  name: "r-smart-offer-bundle-treasure-type",
  props: {
    model: VueTypes.instanceOf(SmartOfferBundleTreasureType),
    label: VueTypes.string.def("Kind:")
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return SmartOfferBundleTreasureType.getValues();
    }
  }
}
</script>